import { ArrowRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const CTA = () => {
	return (
		<section className="py-24 bg-slate-900 text-white">
			<div className="max-w-4xl mx-auto px-6 text-center">
				<h2 className="text-4xl font-bold mb-6">Ready to Start Your Success Story?</h2>
				<p className="text-xl text-slate-300 mb-12 leading-relaxed">
					Let's discuss how we can help you achieve similar results for your business through innovative technology solutions.
				</p>

				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<Link 
						to="/contact"
						className="bg-white text-slate-900 px-8 py-4 rounded-xl font-semibold hover:bg-slate-100 transition-all flex items-center justify-center"
					>
						Start Your Project <ArrowRight className="ml-2 w-5 h-5" />
					</Link>
					<Link 
						to="/schedule-consultation"
						className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-slate-900 transition-all"
					>
						Schedule Consultation
					</Link>
				</div>
			</div>
		</section>
	);
};

export default CTA;